import { createSelector } from '@reduxjs/toolkit'
import min from 'date-fns/min'
import max from 'date-fns/max'

import { financialStatementsSelector } from '../financialStatement'

const taxReturnAnalysisSelector = (state) => state.taxReturn.taxReturnAnalysis

const taxReturnAnalysisListSelector = (state) =>
  state.taxReturn.taxReturnAnalysisList

const taxReturnsSelector = (state) => state.taxReturn.taxReturns

const taxReturnInputsSelector = (state) => state.taxReturn.taxReturnInputs

const sectorAnalysisSelector = (state) => state.taxReturn.sectorAnalysis

const actsSelector = (state) => state.taxReturn.acts

const sectorAnalysisByIdSelector = (state) => state.taxReturn.sectorAnalysisById

const articlesOfAssociationSelector = (state) =>
  state.taxReturn.articlesOfAssociation

const registrationProofSelector = (state) => state.taxReturn.registrationProof

const taxClearanceCertificateSelector = (state) =>
  state.taxReturn.taxClearanceCertificate

const taxReturnAnalysisDateSelector = (state) =>
  new Date(state.taxReturn.taxReturnAnalysisDate)

const yearTaxReturnAnalysisListSelector = createSelector(
  taxReturnAnalysisListSelector,
  taxReturnAnalysisDateSelector,
  (list, date) =>
    list?.filter(
      (t) => new Date(t.closing_date).getFullYear() === date.getFullYear()
    )
)

const taxReturnAnalysisDateRangeSelector = createSelector(
  taxReturnAnalysisSelector,
  (data) => {
    const dates = data?.map((t) => new Date(t.closing_date))

    return data?.length ? { min: min(dates), max: max(dates) } : undefined
  }
)

const getGroupKey = (item) => `${item.closing_year}|${item.closing_date || ''}`

const taxReturnAndFinancialStatements = createSelector(
  taxReturnsSelector,
  financialStatementsSelector,
  (taxReturn, financialStatements) => {
    const taxReturnGroups = {}

    const trResults = taxReturn?.result || []

    trResults.forEach((d) => {
      const key = getGroupKey(d)

      if (!taxReturnGroups[key]) taxReturnGroups[key] = []
      taxReturnGroups[key].push(d)
    })

    const fsGroups = {}

    const fsResults = financialStatements?.result || []

    fsResults.forEach((d) => {
      const key = getGroupKey(d)

      if (!fsGroups[key]) fsGroups[key] = []
      fsGroups[key].push(d)
    })

    return [
      ...new Set([...Object.keys(taxReturnGroups), ...Object.keys(fsGroups)]),
    ]
      .sort()
      .reverse()
      .map((key) => {
        const [closing_year] = key.split('|')

        return {
          closing_year,
          taxReturn: {
            STANDALONE:
              taxReturnGroups[key]?.find((d) => d?.type === 'COMPLETE') ||
              taxReturnGroups[key]?.find((d) => d?.type === 'SIMPLIFIED'),
            CONSOLIDATED: taxReturnGroups[key]?.find(
              (d) => d?.type === 'CONSOLIDATED'
            ),
          },
          financialStatement: {
            STANDALONE: fsGroups[key]?.find(
              (d) => d?.type === 'STANDALONE' || d?.type === null
            ),
            CONSOLIDATED: fsGroups[key]?.find(
              (d) => d?.type === 'CONSOLIDATED'
            ),
          },
        }
      })
  }
)

export {
  taxReturnAnalysisSelector,
  taxReturnAnalysisListSelector,
  taxReturnsSelector,
  taxReturnInputsSelector,
  registrationProofSelector,
  articlesOfAssociationSelector,
  actsSelector,
  taxReturnAnalysisDateSelector,
  yearTaxReturnAnalysisListSelector,
  taxReturnAnalysisDateRangeSelector,
  sectorAnalysisSelector,
  taxReturnAndFinancialStatements,
  sectorAnalysisByIdSelector,
  taxClearanceCertificateSelector,
}
